import { StatusBadgeTone } from '../components/status-badge/status-badge.component';

/**
 * Mapeamento canônico status→tone para badges de STATUS DE CONTRATO
 * (StageName/Status/StatusOverride). Fonte única para todas as telas que
 * exibem um badge de status de contrato, para manter cores/regras idênticas
 * em todo o sistema.
 */
export function contractStatusTone(
  status?: string,
  opts?: { toReverse?: boolean }
): StatusBadgeTone {
  const normalized = (status || '').toLowerCase().trim();

  if (
    normalized.includes('cancelad') ||
    normalized.includes('reprovad') ||
    normalized.includes('estornad') ||
    normalized === 'a estornar' ||
    normalized === 'estornar' ||
    opts?.toReverse === true
  ) {
    return 'danger';
  }

  if (
    /faturado|liberado|pago|registrado|aprovado|ativo|integrado/.test(normalized) &&
    !/pré|pre-|parcial|manual/.test(normalized)
  ) {
    return 'success';
  }

  if (/andamento|pendente|aguardando|pré|pre-|elaborado|refaturado/.test(normalized)) {
    return 'warning';
  }

  return 'neutral';
}

/**
 * Mapeamento canônico status→tone para badges de STATUS DE LOTE/FATURAMENTO
 * (BatchStatus/StatusOfOnlending). Fonte única para todas as telas que
 * exibem um badge de status de lote, para manter cores/regras idênticas
 * em todo o sistema.
 */
export function batchStatusTone(
  status?: string,
  opts?: { integrationError?: boolean }
): StatusBadgeTone {
  if (opts?.integrationError) {
    return 'danger';
  }

  const normalized = (status || '').toLowerCase().trim();

  if (normalized.includes('cancelad') || normalized.includes('reprovad')) {
    return 'danger';
  }

  if (
    /faturado|aprovado|liberado|pago|integrado|ativo/.test(normalized) &&
    !/pré|pre-/.test(normalized)
  ) {
    return 'success';
  }

  if (/andamento|pendente|aguardando|pré|pre-/.test(normalized)) {
    return 'warning';
  }

  return 'neutral';
}
